<template>
  <div
    class="my-3"
    v-if="isIncluded"
  >
    <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
      <h3 class="mr-2">{{ displayLabel }}</h3>
      {{ $t(indicator.nameKey) }}
    </div>
    <component
      :is="chartComponent"
      :filterProp="chartInfo"
      :isResult="true"
      :review="chartInfo ? chartInfo.review || '' : ''"
      :institution="institution"
      :unidades="resolvedUnidades"
      v-bind="extraPropsObj"
    />
  </div>
</template>

<script>
import { getCategoryById } from '../../../indicators/indicatorRegistry'
import { componentMap } from '../../../indicators/indicatorComponents'

export default {
  name: 'IndicatorResultPanel',

  props: {
    indicator: { type: Object, required: true },
    chartInfos: { type: Array, default: () => [] },
    institution: { type: Object, default: () => ({}) },
    unidades: { type: Array, default: () => [] },
    standardEquipments: { type: Array, default: () => [] },
    useChartInfoUnidades: { type: Boolean, default: false },
  },

  computed: {
    chartInfo() {
      return this.chartInfos.find(
        (x) => x.chart === this.indicator.legacyKey
      )
    },

    isIncluded() {
      return !!this.chartInfo
    },

    resolvedUnidades() {
      if (this.useChartInfoUnidades && this.chartInfo) {
        return this.chartInfo.unidadeIds || []
      }
      return this.unidades
    },

    displayLabel() {
      const cat = getCategoryById(this.indicator.categoryId)
      return `${cat.prefix}.${this.indicator.displayNumber}`
    },

    chartComponent() {
      const loader = componentMap[this.indicator.componentName]
      return loader || null
    },

    extraPropsObj() {
      const props = {}
      if (this.indicator.extraProps.includes('standardEquipments')) {
        props.standardEquipments = this.standardEquipments
      }
      return props
    },
  },
}
</script>
